// extracted by mini-css-extract-plugin
export default {"item":"user_profile_notifications_form__item--oofC","label":"user_profile_notifications_form__label--so4L"};